// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-content-support {
    flex-grow: 1;
}

.support-search-filters {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 20px;
    border: 1px solid #ddd;
    background-color: #f8f9fa;
    border-radius: 5px;
    margin-bottom: 20px;
}

.support-search-filters label {
    font-weight: bold;
}

.support-search-filters .filter-select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 200px;
}

.support-search-filters .filter-input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    flex-grow: 1;
}

.search-button-support {
    display: block;
    width: 343px;
    padding: 15px;
    background-color: #222;
    color: white;
    font-size: 18px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin: 30px auto;
}


.support-list-container {
    margin-top: 30px;
}

.support-list-header {
    margin-bottom: 15px;
}

.support-list-header span {
    font-size: 16px;
    font-weight: bold;
}

.support-table {
    width: 100%;
    border-collapse: collapse;
    border-top: 2px solid #333;
}

.support-table th,
.support-table td {
    text-align: center;
    padding: 15px 10px;
    border-bottom: 1px solid #ddd;
}

.support-table th {
    font-weight: bold;
    background-color: #f8f9fa;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .support-search-filters {
        flex-wrap: wrap;
    }

    .support-search-filters .filter-select,
    .support-search-filters .filter-input {
        width: 100%;
        flex-grow: 0;
    }

    .search-button-support {
        width: 100%;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .support-table thead {
        display: none;
    }

    .support-table, .support-table tbody, .support-table tr, .support-table td {
        display: block;
        width: 100%;
    }

    .support-table tr {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
    }

    .support-table td {
        text-align: right;
        padding-left: 50%;
        position: relative;
    }

    .support-table td::before {
        content: attr(data-label);
        position: absolute;
        left: 15px;
        width: calc(50% - 30px);
        padding-right: 10px;
        white-space: nowrap;
        text-align: left;
        font-weight: bold;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/CustomerSupportPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA,+BAA+B;AAC/B;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;QACV,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;IACrB;AACJ","sourcesContent":[".admin-content-support {\n    flex-grow: 1;\n}\n\n.support-search-filters {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    padding: 20px;\n    border: 1px solid #ddd;\n    background-color: #f8f9fa;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n.support-search-filters label {\n    font-weight: bold;\n}\n\n.support-search-filters .filter-select {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    width: 200px;\n}\n\n.support-search-filters .filter-input {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    flex-grow: 1;\n}\n\n.search-button-support {\n    display: block;\n    width: 343px;\n    padding: 15px;\n    background-color: #222;\n    color: white;\n    font-size: 18px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin: 30px auto;\n}\n\n\n.support-list-container {\n    margin-top: 30px;\n}\n\n.support-list-header {\n    margin-bottom: 15px;\n}\n\n.support-list-header span {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.support-table {\n    width: 100%;\n    border-collapse: collapse;\n    border-top: 2px solid #333;\n}\n\n.support-table th,\n.support-table td {\n    text-align: center;\n    padding: 15px 10px;\n    border-bottom: 1px solid #ddd;\n}\n\n.support-table th {\n    font-weight: bold;\n    background-color: #f8f9fa;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .support-search-filters {\n        flex-wrap: wrap;\n    }\n\n    .support-search-filters .filter-select,\n    .support-search-filters .filter-input {\n        width: 100%;\n        flex-grow: 0;\n    }\n\n    .search-button-support {\n        width: 100%;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .support-table thead {\n        display: none;\n    }\n\n    .support-table, .support-table tbody, .support-table tr, .support-table td {\n        display: block;\n        width: 100%;\n    }\n\n    .support-table tr {\n        margin-bottom: 15px;\n        border: 1px solid #ddd;\n        border-radius: 5px;\n        overflow: hidden;\n    }\n\n    .support-table td {\n        text-align: right;\n        padding-left: 50%;\n        position: relative;\n    }\n\n    .support-table td::before {\n        content: attr(data-label);\n        position: absolute;\n        left: 15px;\n        width: calc(50% - 30px);\n        padding-right: 10px;\n        white-space: nowrap;\n        text-align: left;\n        font-weight: bold;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
